export default __webpack_public_path__ + "static/media/constipation@3x.674979b4.jpg";